exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-card[data-v-26289b9c]{background:#fff;border-radius:4px}.page-card .page-card_head[data-v-26289b9c]{padding:0.24rem 0.32rem;border-bottom:1px solid #F0F0F0;font-size:0.22rem;font-weight:bold}.page-card .page-card_body[data-v-26289b9c]{padding:0.24rem 0.32rem}\n", ""]);

// exports
